import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { createRootRoute, createRoute, createRouter, Outlet, RouterProvider } from '@tanstack/react-router';
import { AdminApp } from './routes/AdminApp';
import { HomePage } from './routes/HomePage';
import { AuthProvider } from './lib/auth';
import { initSentry } from './lib/sentry';
import './styles.css';

initSentry();

const ReferenceSnapshot = lazy(() =>
  import('./routes/ReferenceSnapshot').then((module) => ({ default: module.ReferenceSnapshot }))
);

const rootRoute = createRootRoute({
  component: () => <Outlet />
});

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage
});

const adminRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  component: AdminApp
});

const referenceRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/reference',
  component: () => (
    <Suspense fallback={<main className="referenceLoading">Referenz wird geladen...</main>}>
      <ReferenceSnapshot />
    </Suspense>
  )
});

const routeTree = rootRoute.addChildren([indexRoute, adminRoute, referenceRoute]);

const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>
);
